module.exports = __webpack_public_path__ + "static/media/testttt-03.31ae6940.svg";